<h4 class="bold">{{ products.length > 1 ? 'Producten' : title }}:</h4>
<div class="products-container">
  <ng-container
    *ngFor="let product of products; let index = index; let last = last"
  >
    <div
      class="d-flex mb-1"
      [class.clickable]="
        !client &&
        product.type === 'IPBoard' &&
        product?.boardPart?.sign?.id != null
      "
      (click)="tryRouteToSign(product, 'boardPart')"
    >
      <p class="accent ft-17 mb-0">
        {{ product.leftRightBoard ? 'Links' : '' }}
        {{ product | productTypeConfig : 'boardPart' : pipeTriggerCounter }}
      </p>
      <p
        class="accent ft-17 mb-0 ml-1"
        [innerHTML]="getProductSize(product)"
      ></p>
      <p *ngIf="!installerView" class="default ft-17 ml-2 mb-0">
        {{ product | productStockConfig : 'boardPart' : pipeTriggerCounter }}
      </p>
      <div
        *ngIf="showArchivedSignWarningLeft"
        [matTooltip]="'Dit bord is verwijderd'"
      >
        <mat-icon class="archived-warning-icon">report_problem</mat-icon>
      </div>
    </div>
    <div
      *ngIf="product.leftRightBoard"
      class="d-flex mb-1"
      [class.clickable]="
        !client &&
        product.type === 'IPBoard' &&
        product?.otherSideBoardPart?.sign?.id != null
      "
      (click)="tryRouteToSign(product, 'otherSideBoardPart')"
    >
      <p class="accent ft-17 mb-0">
        Rechts
        {{
          product
            | productTypeConfig : 'otherSideBoardPart' : pipeTriggerCounter
        }}
      </p>
      <p
        class="accent ft-17 mb-0 ml-1"
        [innerHTML]="getProductSize(product)"
      ></p>
      <p *ngIf="!installerView" class="default ft-17 ml-2 mb-0">
        {{
          product
            | productStockConfig : 'otherSideBoardPart' : pipeTriggerCounter
        }}
      </p>
      <div
        *ngIf="showArchivedSignWarningRight"
        [matTooltip]="'Dit bord is verwijderd'"
      >
        <mat-icon class="archived-warning-icon">report_problem</mat-icon>
      </div>
    </div>
    <div [class.mb]="!last">
      <p class="bold ft-17 mb-0">
        {{ product | productPlacementConfig : pipeTriggerCounter }}
      </p>
    </div>
    <div *ngIf="projectPlacement?.secondBoard" [class.mb]="!last">
      <p class="bold ft-17 mb-0">
        {{ projectPlacement?.secondBoard?.secondBoardConfiguration }}
      </p>
    </div>
  </ng-container>
</div>
